import type { RouterOutputs } from "@repo/api";
import type { ReactNode } from "react";
import { useEffect, useState } from "react";
import { useShallow } from "zustand/react/shallow";

import PaymentMethodDialog from "~/components/payment-method/payment-method-dialog";
import { PaymentMethodContext } from "~/hooks/use-payment-method";
import { api } from "~/lib/api";
import { useLoadingStore } from "~/stores/use-loading-store";
import { UnsavedChangesProvider } from "./unsaved-changes-provider";

export type PaymentMethod = RouterOutputs["paymentMethod"]["getAll"][number];

interface PaymentMethodProviderProps {
  children: ReactNode;
}

export const PaymentMethodProvider = ({
  children,
}: PaymentMethodProviderProps) => {
  const [softPosEnabled, setSoftPosEnabled] = useState(false);
  const [mollieT2PEnabled, setMollieT2PEnabled] = useState(false);

  const { data: paymentMethods, isFetching: isPaymentMethodsLoading } =
    api.paymentMethod.getAll.useQuery(undefined, {
      initialData: [],
    });

  const { setLoadingStage } = useLoadingStore(
    useShallow((state) => ({
      setLoadingStage: state.setCurrentLoadingStage,
    })),
  );

  useEffect(() => {
    if (isPaymentMethodsLoading) {
      setLoadingStage("paymentMethods");
    } else {
      setLoadingStage(undefined);
    }
  }, [isPaymentMethodsLoading, setLoadingStage]);

  const context = {
    paymentMethods,
    softPosEnabled,
    setSoftPosEnabled,
    mollieT2PEnabled,
    setMollieT2PEnabled,
  };

  return (
    <PaymentMethodContext.Provider value={context}>
      {children}
      <UnsavedChangesProvider>
        <PaymentMethodDialog />
      </UnsavedChangesProvider>
    </PaymentMethodContext.Provider>
  );
};
